// import faker from "faker";
import {randomColor} from "./utils";

export default function makeData(datos,cols) {
  // let options = [
  //   {label: 'bike', backgroundColor: '#B0FC38'},
  //   {label: 'van', backgroundColor: '#9A7B4F'}
  // ];

  // {
  //   id: "transptype_id",
  //   label: "Id",
  //   accessor: "transptype_id",
  //   width: 20,
  //   dataType: "number",
  //   options: []
  // },
  // {
  //   id: "transptype_routing",
  //   label: "Type",
  //   accessor: "transptype_routing",
  //   width: 100,
  //   dataType: "select",
  //   options: options
  // },

  // console.log(cols,'cols')
  // console.log(datos,'datos')
  let columns=[]
  for (let i = 0; i < cols.length; i++) {
    if(cols[i]!=='None'){
      columns.push({
        id: cols[i],
        label: cols[i],
        accessor: cols[i],
        width: 120,
        dataType: "text",
        options: []
      })
    }
  }
  
  let dat=datos
  for (let i = 0; i < dat.length; i++) {
    delete dat[i].None
  }
  

  // console.log(columns,'columns')
  return {columns: columns, data: dat, skipReset: false};
}
